/**
 * This file contains the defaults meta tags injected when no other
 * availbale metas are present
 *
 */

export const defaultMetas = {
  fr: {
    title: "Vestiaire Collective : Dépot vente luxe, mode d'occasion",
    description:
      // tslint:disable-next-line: max-line-length
      "Leader mondial de la mode d'occasion, nous proposons un catalogue inspirant de plus 700.000 articles et plus 5.200 marques. ✅ Jusqu'à -70% du prix neuf !",
    keywords:
      // tslint:disable-next-line: max-line-length
      "Vestiaire Collective, marques de luxe, vêtements de créateurs d'occasion, mode, montres de luxe, sacs à main, chaussures en ligne, bijoux, vintage, femmes, hommes",
    searchTitle:
      // tslint:disable-next-line: max-line-length
      '≡ searchValue - Mode de Seconde Main 2020 !',
    searchDescription:
      "ll➤ Laissez-vous séduire par notre collection de searchValue, ainsi qu’un grand choix d'articles de luxe ! ✅ Jusqu'à -70% du prix du neuf ! ✅Paiement 3 fois ✅ Livraison rapide"
  },
  en: {
    title: 'Luxury resale store, find pre-owned fashion on Vestiaire Collective',
    description:
      // tslint:disable-next-line: max-line-length
      'VestiaireCollective.com, the best of pre-owned fashion at 30 to 70% off original retail price. ✅ Buy! Sell! Share! ✅ 100% of the items are curated and manually controlled by our experts!',
    keywords:
      // tslint:disable-next-line: max-line-length
      'Vestiaire Collective, luxury brands, second hand designer clothes, fashion, luxury watches, handbags, shoes online, jewelry, vintage, women, men',
    searchTitle:
      // tslint:disable-next-line: max-line-length
      '≡ searchValue - Second Hand Fashion 2020!',
    searchDescription:
      'll➤ Let yourself be seduced by our collection of searchValue, as well as a large selection of luxury items! ✅ Up to -70% off of the retail price! ✅ 3 time payments ✅ Fast delivery'
  },
  it: {
    title: 'La migliore selezione di capi di moda sino a -70% del prezzo in negozio! - Vestiaire Collective',
    description:
      // tslint:disable-next-line: max-line-length
      'Vestiaire Collective, il miglior marketplace di moda second-hand con prezzi fino al 70% in meno rispetto a quelli in boutique. ✅ Acquista, Vendi, Condividi! ✅ 100% degli articoli sono selezionati e controllati dai nostri esperti!',
    keywords:
      // tslint:disable-next-line: max-line-length
      'Vestiaire Collective, marchi di lusso, abiti firmati di seconda mano, moda, orologi di lusso, borse, scarpe online, gioielli, vintage, donne, uomini',
    searchTitle:
      // tslint:disable-next-line: max-line-length
      '≡ searchValue - Moda della Seconda mano 2020!',
    searchDescription:
      'll➤ Lasciati sedurre dalla nostra collezione di searchValue e da una vasta selezione di articoli di lusso! ✅ Fino al -70% del prezzo del nuovo! ✅ Pagamento in 3 volte ✅ Consegna rapida'
  },
  de: {
    title: 'Vestiaire Collective : Kaufen und verkaufen Sie Premium- und Luxusmode aus zweiter Hand',
    description:
      // tslint:disable-next-line: max-line-length
      'VestiaireCollective, die beste Secondhand- Mode für 30- bis 70% weniger als der originale Kaufpreis. ✅ Kaufen! Verkaufen! Teilen! ✅ 100% aller Artikel sind von unseren Experten kuratiert und manuell überprüft!',
    keywords:
      // tslint:disable-next-line: max-line-length
      'Vestiaire Collective, Luxusmarken, Second-Hand-Designer-Kleidung, Mode, Luxusuhren, Handtaschen, Schuhe online, Schmuck, Vintage, Frauen, Männer',
    searchTitle:
      // tslint:disable-next-line: max-line-length
      '≡ searchValue - Second Hand Mode 2020!',
    searchDescription:
      'll➤ Lassen Sie sich von unserer Kollektion searchValue sowie einer großen Auswahl an Luxusartikeln verführen! ✅ Bis zu -70% des Neupreises! ✅ Ratenzahlung möglich ✅ Schnelle Lieferung'
  },
  es: {
    title: 'Vestiaire Collective : El mejor sitio donde intercambiar ropa del mundo. Compra, vende y recicla',
    description:
      // tslint:disable-next-line: max-line-length
      'Vestiairecollective.com, ¡la plataforma de compraventa de lujo! ✅ ¡Compra, vende y vacía tu armario! ✅ ¡Encuentra el artículo de tus sueños! Nuestros equipos seleccionan y examinan todos nuestros artículos.',
    keywords:
      // tslint:disable-next-line: max-line-length
      'Vestiaire Collective, marcas de lujo, ropa de diseñador de segunda mano, moda, relojes de lujo, bolsos, zapatos en línea, joyas, vintage, mujeres, hombres',
    searchTitle:
      // tslint:disable-next-line: max-line-length
      '≡ searchValue - Moda de Segunda Mano 2020 !',
    searchDescription:
      'll➤ ¡Déjese seducir por nuestra colección de searchValue, así como por una gran selección de artículos de lujo! ✅ ¡Hasta -70% del precio nuevo! ✅ Pago en 3 veces ✅ Envío rápido'
  },
  us: {
    title: 'Luxury resale store, find pre-owned fashion on Vestiaire Collective',
    description:
      // tslint:disable-next-line: max-line-length
      'VestiaireCollective.com, the best of pre-owned fashion at 30 to 70% off original retail price. ✅ Buy! Sell! Share! ✅ 100% of the items are curated and manually controlled by our experts!',
    keywords:
      // tslint:disable-next-line: max-line-length
      'Vestiaire Collective, luxury brands, second hand designer clothes, fashion, luxury watches, handbags, shoes online, jewelry, vintage, women, men',
    searchTitle:
      // tslint:disable-next-line: max-line-length
      '≡ searchValue - Second Hand Fashion 2020!',
    searchDescription:
      'll➤ Let yourself be seduced by our collection of searchValue, as well as a large selection of luxury items! ✅ Up to -70% off of the retail price! ✅ 3 time payments ✅ Fast delivery'
  }
};

// tslint:disable: max-line-length
export const journalMainPageMetas = {
  fr: {
    title: 'Journal : Tendances et guides de mode | Vestiaire Collective',
    description: {
      default:
        "ll➤ Découvrez le journal de Vestiaire Collective. ✔️ Reportages sur les dernières tendances, interviews de la communauté et anecdotes sur l'histoire de la mode.",
      categories: {
        'inside-vestiaire':
          'Entrez dans les coulisses de Vestiaire Collective, et découvrez les garde-robes et personnalités de nos super équipes à travers le monde.',
        'how-to-style-it':
          'La mode ? C’est tout un art. Heureusement, nous en connaissons un rayon sur le sujet et nous vous en révélons tous les secrets ! Découvrez nos nombreuses idées de la saison pour porter et réinventer vos pièces préférées.',
        'labels-we-love':
          'Grandes maisons de luxe ou plus petites marques locales, rejoignez-nous pour découvrir tous les secrets des marques les plus appréciées.',
        sustainability:
          'Nous savons que vous aimez la mode circulaire, c’est d’ailleurs l’une des raisons pour lesquelles vous êtes des nôtres. Découvrez tout sur la durabilité et ce que nous pouvons faire ensemble pour améliorer l’industrie de la mode.',
        'fashion-stories':
          'Grâce à notre équipe de stylistes, découvrez des looks pointus des icônes mode et leurs wishlists pour cette saison.',
        'my-community':
          "Vestiaire Collective, c'est avant tout une communauté. Des vendeurs pros aux experts d’un style en particulier, en passant par les membres les plus cool du monde entier, découvrez les personnalités uniques qui la compose.",
        promotions:
          'Ici, la chance vous sourit à tous les coups. Profitez de super offres et des meilleures réductions sur des pièces uniques, ou participez à l’un de nos célèbres jeux-concours pour décrocher votre prochain trésor.',
        'fashion-report':
          "En tant qu'experts de la mode, la durabilité et la seconde main n’ont plus de secret pour nous. Et tout ce que nous savons, nous aimons le partager avec notre communauté ! Installez-vous aux premiers rangs et découvrez nos reportages passionnants."
      }
    }
  },
  en: {
    title: 'Journal : Fashion Trends & Guides | Vestiaire Collective',
    description: {
      default:
        'll➤ Get into the Vestiaire Collective Journal. ✔️ Explore trend features, community interviews and fabulous stories from the world of fashion.',
      categories: {
        'inside-vestiaire':
          'Discover more about how Vestiaire Collective works behind the scenes, and explore the personalities and wardrobes that make up our wonderful teams across the world.',
        'how-to-style-it':
          "There's an art to style. Luckily we know a thing or two, and we're happy to share it with you! Explore all the latest seasonal ideas for wearing and rewearing your favourite pieces.",
        'labels-we-love':
          "Whether it's an international catwalk brand or a local indie label, join us as we delve deeper into the brands that we (and you) can't get enough of.",
        sustainability:
          "We know you're into circular fashion, that's one of the reasons why you're here. Discover more about sustainability and how we can all do our bit to change the fashion industry for the better.",
        'fashion-stories':
          'Direct from our style team, explore the style of lesser-known cult icons, and see the pieces that they have on their wishlists this season.',
        'my-community':
          "At Vestiaire Collective, we couldn't do what we do without our community. From Professional Sellers to niche specialists, to cool members from across the globe, we meet the people that make Vestiaire special.",
        promotions:
          'Feeling lucky? This is the place to find super deals and top discounts on special pieces, play one of our infamous competitions, or simply get involved and win yourself a big prize.',
        'fashion-report':
          "As experts in our field, we know a thing our two about the world of sustainable, second-hand fashion. And what's more, we love sharing our knowledge with our community! Here you'll discover our fascinating in-depth reports from the front lines of fashion."
      }
    }
  },
  it: {
    title: 'Journal: Guide su moda e trend | Vestiaire Collective',
    description: {
      default:
        'll➤ Scopri il Journal di Vestiaire. ✔️ Trend, interviste con la community e incredibili aneddoti del mondo della moda in esclusiva per te.',
      categories: {
        'inside-vestiaire':
          'Scopri come Vestiaire Collective lavora dietro le quinte, esplorando personalità e guardaroba dei nostri meravigliosi utenti in tutto il mondo.',
        'how-to-style-it':
          "Lo stile? È un'arte! Per fortuna che Vestiaire se ne intende… ed è felice svelartene tutti i segreti! Scopri le ultime novità della stagione e tante idee per re-indossare e reinventare i tuoi pezzi preferiti.",
        'labels-we-love':
          'Ami le maison di haute couture internazionale ma anche le label indie locali? Unisciti a noi per scoprire tutti i segreti dei brand più amati.',
        sustainability:
          'Sappiamo che ti piace la moda circolare – ed è uno dei motivi per cui sei su Vestiaire. Scopri tutto sulla sostenibilità e su come insieme possiamo fare la differenza nel settore della moda.',
        'fashion-stories':
          'Direttamente dal nostro team di stile, scopri lo stile delle icone più amate... e i pezzi di stagione che hanno nella loro wishlist!',
        'my-community':
          'Vestiaire Collective vive per la nostra community: dai Professional Seller agli esperti specializzati, passando per i nostri incredibili utenti sparsi per il mondo… queste sono le persone speciali che rendono Vestiaire così unico.',
        promotions:
          'Vuoi tentare la fortuna? Questo è il posto giusto per accaparrarti super offerte e i migliori sconti su pezzi unici, partecipare a uno dei nostri celebri concorsi o semplicemente vincere premi in palio.',
        'fashion-report':
          'Siamo esperti nel nostro campo – e la nostra expertise del mondo della moda sostenibile e pre-loved è pluriennale. Senza contare che amiamo condividere le nostre conoscenze con la community! Qui scoprirai i più interessanti approfondimenti fashion direttamente dagli insider.'
      }
    }
  },
  de: {
    title: 'Journal : Fashion Trends & Guides | Vestiaire Collective',
    description: {
      default:
        'll➤ Entdecken Sie das Vestiaire Collective Journal. ✔️ Mit Trendfeatures, Community-Interviews und fabelhaften Geschichten aus der Modewelt.',
      categories: {
        'inside-vestiaire':
          'Werfen Sie einen Blick hinter die Kulissen von Vestiaire Collective und erfahren Sie mehr über die kreativen Köpfe und stylishen Kleiderschränke unserer vielfältigen, auf der ganzen Welt verteilten Teams.',
        'how-to-style-it':
          'Styling ist eine wahre Kunst für sich - und wir weihen Sie liebend gerne in unsere Stilgeheimnisse ein! Lassen Sie Ihrer Kreativität freien Lauf mit unseren Tipps zum Tragen und erneuten Tragen Ihrer absoluten Lieblingsstyles.',
        'labels-we-love':
          'Ganz gleich, ob international bekannte High Fashion-Marke oder lokaler Indie-Designer, tauchen Sie mit uns zusammen ein in die Welt der heiß begehrten Labels, von denen wir (und Sie) nicht genug bekommen können. ',
        sustainability:
          'Dass Ihnen Circular Fashion am Herzen liegt, wissen wir - sonst wären Sie schließlich nicht hier. Erfahren Sie mehr über Nachhaltigkeit und wie wir alle unseren aktiven Beitrag dazu leisten können, die Modebranche zum Besseren zu verändern.',
        'fashion-stories':
          'Zelebrieren Sie den Stil inspirierender Kultikonen und entdecken Sie die heiß begehrten Styles mit Blickfanggarantie, die in dieser Saison ganz oben auf ihren Wunschlisten stehen. ',
        'my-community':
          'Unsere Community bildet das Herzstück von allem, was wir bei Vestiaire Collective tun. Von Professionellen Verkäufern über spezialisierte Fashion-Experten bis hin zu den stylishsten Mitgliedern aus aller Welt - wir präsentieren die faszinierenden Menschen, die Vestiaire einzigartig machen.',
        promotions:
          'Sie wollen das ganz große Style-Los gewinnen? Entdecken Sie unsere großartigen Angebote und Top-Rabatte auf angesagte Styles oder versuchen Sie Ihr Glück bei einem unserer berühmten Wettbewerbe und nehmen Sie Teil für die Chance auf zeitlos stylishe Gewinne.',
        'fashion-report':
          'Als Experten auf unserem Gebiet wissen wir das Eine oder Andere über die Welt der nachhaltigen Second-Hand-Mode. Und vor allem lieben wir es, unser Wissen mit unserer stylishen Community zu teilen! Tauchen Sie mit uns ein in faszinierende Berichte aus der Modebranche.'
      }
    }
  },
  es: {
    title: 'Journal: Tu guía de moda y tendencias | Vestiaire Collective',
    description: {
      default:
        'll➤ Descubre el Journal de Vestiaire Collective ✔️ Explora nuevas tendencias, entrevistas con la comunidad e increíbles historias del mundo de la moda.',
      categories: {
        'inside-vestiaire':
          'Descubre cómo trabaja Vestiaire Collective entre bastidores, explora las personalidades (¡y los armarios!) de nuestros maravillosos equipos en todo el mundo.',
        'how-to-style-it':
          'Crear looks es todo un arte. Pero no te preocupes… ¡te vamos a contar los secretos para lucir un estilo increíble! Explora las últimas ideas de la temporada y aprende como revitalizar tus artículos favoritos.',
        'labels-we-love':
          '¿Te gusta la alta costura? ¿O, quizás prefieres las marcas indie locales? Únete a Vestiaire para descubrir todos los secretos de las marcas más codiciadas del momento',
        sustainability:
          'Sabemos que te gusta la moda circular – y esa es una de las razones por las que estás aquí. Descubre todo sobre la sostenibilidad y cómo, trabajando juntos podemos marcar la diferencia en la industria de la moda.',
        'fashion-stories':
          'Directamente desde nuestro equipo de estilismo, explora el estilo de los iconos de moda menos conocidos y qué artículos acaban de añadir a sus wishlist de la temporada.',
        'my-community':
          'En Vestiaire Collective, no podríamos hacer lo que hacemos sin nuestra comunidad. Desde los vendedores profesionales hasta los expertos de un estilo particular, pasando por los usuarios más geniales alrededor del mundo... Estas son las personas especiales que hacen que Vestiaire sea tan único.',
        promotions:
          '¿Crees que tienes suerte? Vestiaire es el lugar para comprobarlo, con súper ofertas y grandes descuentos en artículos especiales, nuestras famosas competiciones y la posibilidad de ganar muchos premios.',
        'fashion-report':
          'Como expertos en nuestro campo, la moda  sostenible de segunda mano no tiene secretos para nosotros. Y, todo lo que hemos aprendido... ¡nos encanta compartirlo con nuestra comunidad! Aquí descubrirás los más apasionantes detalles de moda.'
      }
    }
  },
  us: {
    title: 'Journal : Fashion Trends & Guides | Vestiaire Collective',
    description: {
      default:
        'll➤ Get into the Vestiaire Collective Journal. ✔️ Explore trend features, community interviews and fabulous stories from the world of fashion.',
      categories: {
        'inside-vestiaire':
          'Discover more about how Vestiaire Collective works behind the scenes, and explore the personalities and wardrobes that make up our wonderful teams across the world.',
        'how-to-style-it':
          "There's an art to style. Luckily we know a thing or two, and we're happy to share it with you! Explore all the latest seasonal ideas for wearing and rewearing your favourite pieces.",
        'labels-we-love':
          "Whether it's an international catwalk brand or a local indie label, join us as we delve deeper into the brands that we (and you) can't get enough of.",
        sustainability:
          "We know you're into circular fashion, that's one of the reasons why you're here. Discover more about sustainability and how we can all do our bit to change the fashion industry for the better.",
        'fashion-stories':
          'Direct from our style team, explore the style of lesser-known cult icons, and see the pieces that they have on their wishlists this season.',
        'my-community':
          "At Vestiaire Collective, we couldn't do what we do without our community. From Professional Sellers to niche specialists, to cool members from across the globe, we meet the people that make Vestiaire special.",
        promotions:
          'Feeling lucky? This is the place to find super deals and top discounts on special pieces, play one of our infamous competitions, or simply get involved and win yourself a big prize.',
        'fashion-report':
          "As experts in our field, we know a thing our two about the world of sustainable, second-hand fashion. And what's more, we love sharing our knowledge with our community! Here you'll discover our fascinating in-depth reports from the front lines of fashion."
      }
    }
  }
};
